import React, { Component } from 'react';
import classNames from 'classnames';

import './NavigationToggle.css'

class NavToggle extends Component {

    handleKeyPress = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.props.toggle();
        }
    }

    render() {

        const { toggle, isOpen, show } = this.props

        const toggleClass = classNames({
            navigationToggle: true,
            closed: !isOpen,
            open: isOpen,
        });


        const toggleStyle = {
            // opacity: show ? 1 : 0,
            transform: show ? 'translateY(0)' : 'translateY(-100px)'
        }

        return (

            <button 
                className={toggleClass} 
                onClick={toggle}
                onKeyPress={this.handleKeyPress}
                style={toggleStyle}
                aria-label={isOpen ? 'Close navigation menu' : 'Open navigation menu'}
                aria-expanded={isOpen}
                aria-controls="main-navigation"
            >
                <span className="line" aria-hidden="true"></span>
                <span className="line line-bottom" aria-hidden="true"></span>
            </button>

        );
    }
}

export default NavToggle;